import React from "react";
import PropTypes from "prop-types";
import {Paper, ListItemButton, ListItemText} from "@mui/material";
import {useSidebarStyles} from "./sidebarStyles";

export const SidebarOverlay = ({
  open,
  children,
  sidebarWidth,
  top,
  anchor = "down",
  buttonHeight = 0,
  parentText,
}) => {
  const {classes} = useSidebarStyles();

  const positionStyle =
    anchor === "up" ?
      {
        left: sidebarWidth,
        bottom: `calc(100vh - ${top + buttonHeight}px)`,
        maxHeight: top + buttonHeight,
      } :
      {
        left: sidebarWidth,
        top,
        maxHeight: `calc(100vh - ${top}px)`,
      };

  return (
    <Paper
      className={classes.overlay}
      style={{
        ...positionStyle,
        width: open ? 200 : 0,
        opacity: open ? 1 : 0,
        pointerEvents: open ? "auto" : "none",
      }}
    >
      {parentText && (
        <ListItemButton className={classes.parentTitle} disableRipple>
          <ListItemText primary={parentText} primaryTypographyProps={{variant: "body2"}} />
        </ListItemButton>
      )}
      {children}
    </Paper>
  );
};

SidebarOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  sidebarWidth: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  anchor: PropTypes.oneOf(["up", "down"]),
  buttonHeight: PropTypes.number,
  parentText: PropTypes.string,
};
